<template>
  <svg
    viewBox="0 0 16 12"
    xmlns="http://www.w3.org/2000/svg"
    :width="props.width"
    class="tw-inline-flex"
    :height="props.height"
    :class="`tw-fill-${props.fill}`"
  >
    <path
      d="M1.33398 1H14.6673M1.33398 6H9.66732M1.33398 11H13.0007"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script lang="ts" setup>
export interface IProps {
  fill?: string;
  width?: string;
  height?: string;
}

const props = withDefaults(defineProps<IProps>(), {
  fill: "white",
  width: "16px",
  height: "16px",
});
</script>

<style scoped></style>
